import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { Card, CardContent } from './ui/Card';
import { InteractiveTerminal } from './InteractiveTerminal';
import { CtaLink } from './CtaLink';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { featuredProducts, moreProducts, deliveryPrinciples } from '../data/products';
export function PortfolioSection() {
  const revealRef = useScrollReveal();
  return <section id="portfolio" ref={revealRef} aria-labelledby="portfolio-nadpis" className="py-20 md:py-32 px-4 sm:px-6 lg:px-8" data-id="element-421" data-mp="1bswuu36r9rai">
      <div className="max-w-7xl mx-auto" data-id="element-422" data-mp="11to37gzd4orb">
        {/* Header */}
        <div className="reveal text-center max-w-3xl mx-auto mb-14 md:mb-20" data-id="element-423" data-mp="11t5v9n3c8m3k">
          <p className="text-xs font-semibold tracking-[0.2em] text-apple-gray uppercase mb-4" data-id="element-424" data-mp="16r7kkprcxhnh">
            Portfólio
          </p>
          <h2 id="portfolio-nadpis" className="text-3xl sm:text-4xl md:text-6xl font-extrabold tracking-tight text-apple-black mb-5" data-id="element-425" data-mp="3mlzp7sj1oo1p">
            20 produktov. Jedna technológia.
          </h2>
          <p className="text-lg md:text-xl text-apple-gray leading-relaxed" data-id="element-426" data-mp="2gqujpkjny0ws">
            Každý koncept je reálny projekt, ktorý vieme dodať ako hotovú PWA. Vyberte si ho alebo prineste vlastný nápad.
          </p>
        </div>

        {/* Featured products */}
        <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto mb-16 md:mb-20" data-id="element-427" data-mp="2pt3w6fyhs4ct">
          {featuredProducts.map((p, i) => <li key={p.title} className={`reveal reveal-delay-${Math.min(i + 1, 5)}`} data-id="element-428" data-mp="2zo46nbo75wis" data-mpi={i}>
              <Card className="h-full border border-gray-200 rounded-3xl overflow-hidden bg-white" data-id="element-429" data-mp="3dgtrhcrzoveb">
                <div className="h-40 relative overflow-hidden" data-id="element-430" data-mp="39eqfmn1erosi">
                  <img src={p.image} alt="" loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-431" data-mp="3nerejwy44m5c" />
                  <div className="absolute bottom-4 left-4 w-11 h-11 bg-white rounded-xl flex items-center justify-center shadow-md" data-id="element-432" data-mp="2g31uf5ncahdu">
                    <p.icon className={`w-5 h-5 ${p.iconClass}`} aria-hidden="true" data-id="element-433" data-mp="2k43v7qwwn1hx" />
                  </div>
                </div>
                <CardContent className="p-6 md:p-8" data-id="element-434" data-mp="2ttnf8zwct1ed">
                  <h3 className="text-xl font-bold text-apple-black mb-2" data-id="element-435" data-mp="2tuf7q1unmj0f">{p.title}</h3>
                  <p className="text-apple-gray leading-relaxed" data-id="element-436" data-mp="2yroz3n1lt4qw">{p.description}</p>
                </CardContent>
              </Card>
            </li>)}
        </ul>

        {/* Remaining concepts */}
        <div className="reveal max-w-4xl mx-auto mb-20 md:mb-28" data-id="element-437" data-mp="37upzd73sg1mn">
          <h3 className="text-xl md:text-2xl font-bold text-apple-black text-center mb-8" data-id="element-438" data-mp="3ct1bjohk2o81">
            Ďalších 14 konceptov
          </h3>
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-12" data-id="element-439" data-mp="1dgyknt6lqrkc">
            {moreProducts.map(item => <li key={item} className="flex items-center gap-3 py-3 border-b border-gray-100" data-id="element-440" data-mp="1igkx40elw3s3">
                <CheckCircle2Icon className="w-4 h-4 text-apple-blue flex-shrink-0" aria-hidden="true" data-id="element-441" data-mp="1awaem88n9sny" />
                <span className="text-sm font-medium text-apple-black" data-id="element-442" data-mp="16264xh7zv6j6">{item}</span>
              </li>)}
          </ul>
          <div className="text-center mt-10" data-id="element-443" data-mp="w6cvi6pknt5m">
            <CtaLink href="#kontakt" className="w-full sm:w-auto" data-id="element-444" data-mp="w7nxc0zgiqu3">
              Začať projekt
            </CtaLink>
          </div>
        </div>

        {/* Delivery principles */}
        <div className="reveal mb-20 md:mb-28" data-id="element-445" data-mp="1ovs64vdbrk10">
          <h3 className="text-2xl md:text-4xl font-bold tracking-tight text-apple-black text-center mb-10 md:mb-14" data-id="element-446" data-mp="1osxn989ym79p">
            Nestaviame prototypy, ale hotové riešenia.
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-447" data-mp="1fw50tyhh5u2o">
            {deliveryPrinciples.map(item => <Card key={item.title} className="rounded-3xl bg-apple-light border-none shadow-none" data-id="element-448" data-mp="4edrcx2a1k1w">
                <CardContent className="p-6 md:p-10" data-id="element-449" data-mp="1sb36qe9zpddh">
                  <div className="w-12 h-12 bg-white rounded-2xl flex items-center justify-center shadow-sm mb-5" data-id="element-450" data-mp="1saa3voe5j80m">
                    <item.icon className="w-6 h-6 text-apple-blue" aria-hidden="true" data-id="element-451" data-mp="1x44qazl5613e" />
                  </div>
                  <h4 className="text-xl md:text-2xl font-bold text-apple-black mb-3" data-id="element-452" data-mp="1nci7ah2kaxq3">{item.title}</h4>
                  <p className="text-apple-gray leading-relaxed" data-id="element-453" data-mp="2b2cgmonoa45l">{item.desc}</p>
                </CardContent>
              </Card>)}
          </div>
        </div>

        {/* Terminal demo */}
        <div className="reveal-scale" data-id="element-454" data-mp="221obkjg9be4u">
          <InteractiveTerminal data-id="element-455" data-mp="220mpzl1m798v" />
        </div>

        {/* Market stat */}
        <div className="reveal text-center" data-id="element-456" data-mp="2628anske4rtm">
          <p className="text-xs font-semibold tracking-[0.2em] text-apple-gray uppercase mb-4" data-id="element-457" data-mp="2616p2u5r0mxn">
            Veľkosť príležitosti
          </p>
          <p className="text-6xl md:text-8xl font-extrabold tracking-tighter text-apple-black" data-id="element-458" data-mp="uocj1kcauqli">$12.4B</p>
        </div>
      </div>
    </section>;
}